import announcementBar from '../components/announcementBar';
import '../components/localization';
import megaMenu from '../components/megaMenu';
import miniCart from '../components/miniCart';
import accordion from '../components/accordion';
import instantSearch from '../objects/search/instantSearch';
import fancyboxPDP from '../components/fancybox_custom';
import shopifyVideo from '../components/video';
import arcText from '../components/arcText';
import uspGlobal from '../components/usp-global';
import recentBlog from '../components/recentBlog';
import mrSliders from '../components/mrSliders';
import bestSeller from '../components/best-seller';
import readMore from '../components/readMore';
import readMoreContentTop from '../components/readMoreContentTop';
import customDropdownFilter from '../components/customDropdownFilter';
import futureGiveback from '../components/future-giveback';
import tabsProducts from '../components/tabsProducts';
import cardAddtoCart from '../components/cardAddtoCart';
import plpYouMayLike from '../components/plpYouMayLike';
import recipesIngredientsProducts from '../components/recipesIngredientsProducts';
import highlightSearchResults from '../objects/search/highlight';
import footer from '../components/footer';
import meetOurGrowers from '../components/meetOurGrowers';
import infiniteScroll from '../components/infiniteScroll';
import initB2BDiscountMessages from '../components/b2bDiscountMessages';
import addToListLogin from '../components/addToListLogin';
import { reconcileCartCompany } from '../objects/cart/cart_company_guard';
import locationSwitcher from '../components/locationSwitcher';
import { CustomProductsSlider } from '../components/custom-products-slider';
import slideshowCustomScrollbar from '../components/slideshowCustomScrollbar';
import iosScrollLockFix from '../components/iosScrollLockFix';
import draftOrderCartSummary from '../components/draftOrderCartSummary';
import saveCartToList from '../components/saveCartToList';
import creditBalanceGate from '../components/creditBalanceGate';
import { RecentlyViewedProducts, trackRecentlyViewed } from '../components/recentlyViewedProducts';

if (!customElements.get('custom-products-slider')) {
  customElements.define('custom-products-slider', CustomProductsSlider);
}
if (!customElements.get('recently-viewed-products')) {
  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}
addToListLogin();
meetOurGrowers();

// run all related funcs here
announcementBar();
megaMenu();
miniCart();
accordion();
instantSearch();
// fancyboxPDP();
shopifyVideo();
arcText();
uspGlobal();
mrSliders();
bestSeller();
readMore();
readMoreContentTop();
customDropdownFilter();
futureGiveback();
tabsProducts();
cardAddtoCart();
plpYouMayLike();
recipesIngredientsProducts();
highlightSearchResults();
footer();
infiniteScroll();
initB2BDiscountMessages();
addToListLogin();
reconcileCartCompany();
// COB2B-809 — sales-rep "Welcome Back!" pop up, once per login. After
// reconcileCartCompany() so a pending native switch is seen and the pop up waits for the
// landing. Also runs logged out, to reset the once-per-login flag on the login portal.
locationSwitcher();
slideshowCustomScrollbar();
document.addEventListener('product-recommendations:loaded', slideshowCustomScrollbar);
// Theme editor re-renders sections (e.g. matching recipes) after load.
document.addEventListener('shopify:section:load', slideshowCustomScrollbar);
iosScrollLockFix();
// No-ops off the cart page. Lives here because the summary renders for every
// customer, while draft_cart.autojs.js only loads for sales reps.
draftOrderCartSummary();
// Cart header's "Save Cart" — delegated, so a no-op off the cart page.
saveCartToList();
// COB2B-762 credit gate. Here rather than on the cart page because the mini-cart
// renders on every page; a no-op without the credit payload (DTC, prepay, sales rep).
creditBalanceGate();
// COB2B-803: records the PDP's handle for the cart's recently viewed carousel; no-op elsewhere.
trackRecentlyViewed();
// draftCart() is loaded separately on cart page via draft_cart.autojs.js
recentBlog();
